<!--人员管理-->
<template>
  <div class="trialScGlIndexClass">
    <div>
      <nav-com activeIndex="6"></nav-com>
    </div>

    <div style="padding: 15px">
      <div style="text-align: left">
        <div class="searchMainClass">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form>
                <el-form-item label="单号： ">
                  <el-input
                    placeholder="请输入单号..."
                    v-model="search.PAYMENT_NO"
                  ></el-input>
                  <label style="margin-left:6px;">姓名/开户行：</label>
                  <el-input
                    placeholder="请输入姓名/开户行..."
                    v-model="search.KHHINFO"
                  ></el-input>
                  <label style="margin-left:6px;">款项名目：</label>
                   <el-select placeholder="请选择" v-model="search.IS_ENABLED">
                    <el-option label="收房佣金" value="0"></el-option>
                    <el-option label="付房款" value="1"></el-option>
                    <el-option label="售房佣金" value="2"></el-option>
                    <el-option label="售房回款" value="3"></el-option>
                    <el-option label="装修付款" value="4"></el-option>
                  </el-select>
                  <label style="margin-left:6px;">是否作废：</label>
                   <el-select placeholder="请选择" v-model="search.IS_ENABLED">
                    <el-option label="正常" value="1"></el-option>
                    <el-option label="作废" value="2"></el-option>
                  </el-select>
                  <el-button
                    type="success"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    综合查询
                  </el-button>
                  <el-button
                    type="warning"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="addCwDj"
                  >
                    添加财务单据
                  </el-button>
                  <el-button
                    type="danger"
                    style="margin-left: 15px;margin-right: 15px"
                    @click="mainLoad"
                  >
                    作废单据
                  </el-button>
                  <div style="float:right;margin-right:10px;">
                    <upload-curr-com
                        :mainLoadData="mainLoad"
                        :op="op"
                        :paramData="search"
                        :tableColumns="tableColumns"
                        mbBtnTxt="导出表格"
                        isUpLoadBtn="0"
                        isDownBtn="1"
                    ></upload-curr-com>
                </div>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
        </div>
      </div>

      <!-- table列表  开始 -->

      <div style="position: relative;">
        <el-table
          height="80vh"
          :data="tableData"
          border
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <template v-for="(col, index) in tableColumns">
            <el-table-column
              :prop="col.colName"
              :label="col.colText"
              :key="index"
              v-if="col.colShow"
            >
            <template slot-scope="scope">
                <div v-if="col.colName==='PERMISSION_ID'||col.colName==='IS_ENABLED'">
                    <div v-if="col.colName==='PERMISSION_ID'">
                        <span v-if="scope.row.PERMISSION_ID==='99'">管理员</span>
                        <span v-if="scope.row.PERMISSION_ID==='1'">店东</span>
                        <span v-if="scope.row.PERMISSION_ID==='2'">经纪人</span>
                        <span v-if="scope.row.PERMISSION_ID==='3'">收房人</span>
                        <span v-if="scope.row.PERMISSION_ID==='4'">出房人</span>
                        <span v-if="scope.row.PERMISSION_ID==='5'">配饰人员</span>
                        <span v-if="scope.row.PERMISSION_ID==='0'">装修公司</span>
                    </div>
                    <div v-else>
                        <span v-if="scope.row.IS_ENABLED==='0'" style="color:red">未启用</span>
                        <span v-if="scope.row.IS_ENABLED==='1'" style="color:green">已启用</span>
                    </div>
                </div>
                <div v-else>
                    {{scope.row[col.colName]}}
                </div>
            </template>
            </el-table-column>
          </template>
          <el-table-column label="操作" width="160" v-if="false">
            <template slot-scope="scope">
              <el-button
                @click="roleBgHandler(scope.row)"
                type="text"
                size="small"
              >
                查看单据
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="float: right;margin-top: 20px;">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageSet.currentPage"
            :page-sizes="pageSet.pageSizeS"
            :page-size="pageSet.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageSet.totalNums"
          >
          </el-pagination>
        </div>
      </div>

      <!-- table列表  结束 -->
        
      <!-- 录入财务单据 开始 -->
      <el-dialog
        :title="'操作单据'"
        :visible.sync="dialogVisible"
        width="96%"
      >
        <span>
          <div class="addClassModel">
            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                 <label style="margin-left:6px;">收/付款人姓名：</label>
                  <el-input
                    v-model="czData.row.XM"
                    style="width:70%;"
                    placeholder="请输入收/付款人姓名..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">收/付款人账号：</label>
                  <el-input
                    v-model="czData.row.ACCOUNT_NO"
                    style="width:70%;"
                    placeholder="请输入收/付款人账号..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                    <label style="margin-left:6px;">收/付款人账号：</label>
                  <el-input
                    v-model="czData.row.BANK_NAME"
                    style="width:70%;"
                    placeholder="请输入收/付款人开户行..."
                  ></el-input>
                </el-col>
              </el-row>
            </div>

            <div style="margin-bottom:20px">
              <el-row>
                <el-col :span="8" style="text-align: left;">
                 <label style="margin-left:6px;">发生金额：</label>
                  <el-input
                    v-model="czData.row.AMOUNT"
                    style="width:70%;"
                    placeholder="请输入发生金额..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                  <label style="margin-left:6px;">实付金额：</label>
                  <el-input
                    v-model="czData.row.PAID_AMOUNT"
                    style="width:70%;"
                    placeholder="请输入PAID_AMOUNT..."
                  ></el-input>
                </el-col>
                <el-col :span="8" style="text-align: left;">
                    <label
                    >&nbsp;&nbsp;<span style="color:red;">*</span
                    >款项名目：</label
                  >
                   <el-select placeholder="请选择" v-model="czData.row.ITEM_CATEGORY">
                    <el-option label="收房佣金" value="0"></el-option>
                    <el-option label="付房款" value="1"></el-option>
                    <el-option label="售房佣金" value="2"></el-option>
                    <el-option label="售房回款" value="3"></el-option>
                    <el-option label="装修付款" value="4"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </div>
          </div>
        </span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">
            取 消
          </el-button>
          <el-button type="primary" @click="roleServerBgHandler">
            确 定
          </el-button>
        </span>
      </el-dialog>
      <!-- 录入财务单据 结束 -->
    </div>
  </div>
</template>

<script>
import NavCom from "../../components/navCom/NavMainCom.vue";
import UploadCurrCom from "../../components/uploadCurrCom/UploadCurrCom.vue";
import allParam from "../../allParam/allParam.vue";
var utilPost, op;
export default {
  name: "CwGlIndex",
  components: { NavCom, UploadCurrCom, allParam },
  data() {
    return {
      rows: [],
      action: allParam.downMbUrl,
      objDataParam: "",
      search: {
      },
      /**分页 开始 */
      pageSet: {
        currentPage: 1, //当前页页码
        pageSizeS: [10, 50, 100, 1000],
        pageSize: 10, //每页默认显示的条数
        totalNums: 0 //数据总条数
      },
      /**分页 结束 */
      tableColumns: [
        {
          colName: "PAYMENT_NO",
          colText: "财务单号",
          colShow: false
        },
        {
          colName: "RELATED_ORDER_ID",
          colText: "关联订单号",
          colShow: true
        },{
          colName: "COMMUNITYNAME",
          colText: "小区名称",
          colShow: true
        },
        {
          colName: "UNIT_NO",
          colText: "单元",
          colShow: true
        },
        {
          colName: "BUILDING_NO",
          colText: "楼栋号",
          colShow: true
        },
        {
          colName: "HOUSE_NO",
          colText: "门牌号",
          colShow: true
        },
        {
          colName: "FLOOR",
          colText: "楼层",
          colShow: true
        },
        {
          colName: "AMOUNT",
          colText: "发生金额",
          colShow: true
        },
        {
          colName: "PAID_AMOUNT",
          colText: "实付金额",
          colShow: true
        },
        {
          colName: "PAYMENT_TIME",
          colText: "发生时间",
          colShow: true
        },
        {
          colName: "ACCOUNT_NO",
          colText: "姓名",
          colShow: true
        },
        {
          colName: "BANK_NAME",
          colText: "开户行名称",
          colShow: true
        },
        {
          colName: "VOUCHER_URL",
          colText: "开户行账号",
          colShow: true
        },
        {
          colName: "CREATE_USER",
          colText: "创建人",
          colShow: true
        },
        {
          colName: "CREATE_TIME",
          colText: "创建时间",
          colShow: true
        },
        {
          colName: "ITEM_CATEGORY",
          colText: "款项名目",
          colShow: true
        },
        
        {
          colName: "FLOW_TYPE",
          colText: "款项类型",
          colShow: true
        },
        {
          colName: "DDZT",
          colText: "财务单状态",
          colShow: true
        }
      ],
      tableData: [],
      czData:{
        row:{}
      },
      dialogVisible:false
    };
  },
  created() {
    this.op = "adminFinanceGl";
    this.utilPost = this.$util.handler;
  },
  mounted() {
    this.mainLoad();
  },
  methods: {
    handleSelectionChange(val) {
      this.rows = val;
    },
    /**分页方法 开始 */
    handleSizeChange(val) {
      this.pageSet.pageSize = val;
      this.mainLoad();
    },
    handleCurrentChange(val) {
      this.pageSet.currentPage = val;
      this.mainLoad();
    },
    //加载主列表数据
    mainLoad() {
      //alert(JSON.stringify(this.pageSet));
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          op: this.op, //反射名称
          methodName: "mainLoad" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          this.isShowContent = false;
          return;
        }
        this.pageSet.totalNums = data.totalNums;
        this.tableData = data.content;
        this.isShowContent = true;
      });
    },
    
    /**分页方法 结束 */
    addCwDj(){
        this.dialogVisible=true
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.trialScGlIndexClass {
  .addClassModel {
    padding-left: 15px;
    padding-right: 15px;
  }
  .trainSetClassMain .el-input {
    width: 60% !important;
  }
  .el-dialog {
    margin-top: 15px !important;
    width: 90%;
  }
  .searchMainClass .el-input {
    width: 150px !important;
  }
  .longLabelClass .el-input {
    width: 372px !important;
  }
  .el-table td.el-table__cell div {
    font-weight: 600 !important;
  }
  .cell {
    text-align: center !important;
  }
  .mainDivJd {
    .el-progress-bar__innerText {
      color: #f300ff !important;
    }
  }

  .fzrsMainDiv {
    text-align: left;
    margin-bottom: 10px;
  }
  .dwInfoDivId {
    .el-form-item__content {
      float: left;
    }
  }
  /deep/ .el-dialog {
    margin-top: 15px !important;
  }
  /deep/ .el-input--small .el-input__inner {
    height: 29px;
    line-height: 29px;
  }
  /deep/ .el-form-item__label {
    line-height: 32px !important;
  }
  /deep/ .el-form-item--small.el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/cwGlIndex/CwGlIndex.vue